require('slick-carousel');
import $ from "jquery";

if($(".widget_btn")){
    $(".widget_btn").click(function(){
        $("#sb_enterprise_widget").trigger("click");
    });
}

// if($('.faq-section .masonry-grid--item-toggler')){
//     $('.faq-section .masonry-grid--item-toggler').on('click', function (){
//         $(this).toggleClass('--active');
//         $(this).closest('.masonry-grid--item').find('.masonry-grid--item-body').slideToggle();
//     })
// }

$(document).ready(function(){
  const slider =  $('.prices-carousel').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    rows: 1,
    swipeToSlide: true,
    centerMode: true,
    centerPadding: '40px',
    infinite: true,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
          breakpoint: 1080,
          settings: {
              adaptiveHeight: true,
              slidesToShow: 2,
              autoplay: true,
              autoplaySpeed: 2000,
              centerPadding: '40px',
          }
      },
      {
          breakpoint: 768,
          settings: {
              centerPadding: '20px',
              centerMode: true,
              adaptiveHeight: true,
              slidesToShow: 1,
              autoplay: true,
              autoplaySpeed: 2000,
          }
      }
    ]
    });

    slider.on('wheel', (function(e) {
        e.preventDefault();

        if (e.originalEvent.deltaY < 0) {
            $(this).slick('slickNext');
        } else {
            $(this).slick('slickPrev');
        }
    }));

    if($('.prices-carousel-wrapper').length){
        $(".prev-btn").click(function () {
            $(".prices-carousel").slick("slickPrev");
        });

        $(".next-btn").click(function () {
            $(".prices-carousel").slick("slickNext");
        });

        $(".prev-btn").addClass("slick-disabled");

        $(".prices-carousel").on("afterChange", function () {
            if ($(".slick-prev").hasClass("slick-disabled")) {
                $(".prev-btn").addClass("slick-disabled");
            } else {
                $(".prev-btn").removeClass("slick-disabled");
            }
            if ($(".slick-next").hasClass("slick-disabled")) {
                $(".next-btn").addClass("slick-disabled");
            } else {
                $(".next-btn").removeClass("slick-disabled");
            }
        });
    }
});



